import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/about/page.tsx")